import { memo } from 'react';
import { LinkButton } from '@page/ui';
import { CheckIcon } from '@page/icons';

interface IntroductoryRailProps {}

const items = [
  'Summarize and review an entire file in minutes',
  'Uncover critical facts with unprecedented precision',
  'Build winning arguments with ease',
  'Seamlessly collaborate with colleagues',
];

const lawFirms = [
  {
    src: 'https://static-assets.pageai.co/law-firms/1-cc.png',
    alt: 'Carpenter Chartered',
  },
  {
    src: 'https://static-assets.pageai.co/law-firms/2-jackson-macnichol.png',
    alt: 'Jackson & MacNichol Attorneys at Law',
  },
  {
    src: 'https://static-assets.pageai.co/law-firms/3-stone-rose.png',
    alt: 'Stone Rose Law',
  },
  {
    src: 'https://static-assets.pageai.co/law-firms/4-west-dunn.png',
    alt: 'West & Dunn',
  },
  {
    src: 'https://static-assets.pageai.co/law-firms/5-andrew-p-gross.png',
    alt: 'Andrew P Gross Attorney At Law',
  },
];

const IntroductoryRailBase = (props: IntroductoryRailProps) => {
  return (
    <aside
      id="introductory-rail"
      className="hidden lg:block lg:flex-1 bg-bg-sur-primary px-[100px] py-14 max-w-[720px]"
    >
      <div className="flex flex-col h-full">
        <div className="flex flex-col justify-center min-h-[80%]">
          <h2 className="text-[34px] font-bold text-text-primary mb-8">Page was built for VA disability</h2>

          <p className="font-heading-xl text-text-primary mb-8">
            Page helps supercharge your practice so you can deliver better outcomes for your veterans.
          </p>

          <div className="flex flex-col gap-8 mb-8">
            {items.map((item) => (
              <div key={item} className="flex items-center gap-4">
                <div className="grid place-items-center rounded-full p-1 bg-[#e0ecff]">
                  <CheckIcon className="size-5 fill-icon-primary" />
                </div>

                <span className="font-heading-xl text-text-primary">{item}</span>
              </div>
            ))}
          </div>

          <LinkButton
            element="a"
            href="https://pageai.co"
            target="_blank"
            className="font-normal font-heading-xl hover:font-medium transition-all"
          >
            Learn more
          </LinkButton>
        </div>

        <div className="flex-1" />

        <div className="flex flex-col gap-2.5">
          <div className="font-heading-l text-[#b5b5b5] font-semibold">TRUSTED BY</div>

          <div className="flex gap-x-12 gap-y-2 flex-wrap">
            {lawFirms.map((firm) => (
              <img key={firm.src} src={firm.src} alt={firm.alt} width={64} height={68} />
            ))}
          </div>
        </div>
      </div>
    </aside>
  );
};

export const IntroductoryRail = memo(IntroductoryRailBase);
